export default {
    asset: {
        asset: {
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/img/segment-layout-default-images/asset/timeline-view.png"
            }
        }
    },
    title: "",
    titleFontSize: "16px",
    borderRadius: "8px",
    borderThickness: "1px",
    borderColor: "layout-border-color",
    cardPadding: "16px"
};
